/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendInteractions.defs.js'
export * as $defs from './sendInteractions.defs.js'
